module.exports = __webpack_public_path__ + "static/media/JPYC.0d1e5d3f.png";